/** Align with backend constants/permissions.js and mst_submodules.submodule_slug */
export const CHEQUE_ISSUES_SUBMODULE_SLUG = "cheque-issues";
export const CHEQUE_COLLECTION_SUBMODULE_SLUG = "cheque-collection";
export const CHEQUE_MASTERS_SUBMODULE_SLUG = "cheque-masters";
